var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.groups),function(group,gindex){return _c('Block',{key:gindex,staticClass:"my-3",attrs:{"group":group,"loading":_vm.loading}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }